import * as React from 'react';

import ClosingCostsTable from './ClosingCostsTable';
import PrepaidsTable from './PrepaidsTable';
import { formatAsDollars, parseNumber } from '../../../../lib/helpers';

import styles from '../../../../styles/sass/pages/Tools.module.scss';

export interface Props {
  location: string;
  percentDownpayment: any;
  price: any;
  traditionalBrokerage: any;
  toriiBrokerage: any;
  prepaidInfo: any;
}

class ClosingCosts extends React.Component<
  Props,
  { showToriiBrokerage: boolean }
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showToriiBrokerage: false,
    };
  }

  toggleSwitch = () => {
    this.setState({
      showToriiBrokerage: !this.state.showToriiBrokerage,
    });
  };
  disclaimerText = (state: string) => {
    switch (state) {
      case 'MA':
        return `* These amounts assume a 4.75% interest rate on a
        30-year mortgage, and property taxes are estimated in Boston
        proper. All of the amounts on this page are meant purely as
        estimates to be used as a guide, not as quotes or set prices
        in any form. If you have questions about any of the above,
        contact us.`;
      case 'CA':
        // TODO: CA disclaimer text
        return `* These amounts assume a 4.75% interest rate on a
        30-year mortgage, and property taxes are estimated in Boston
        proper. All of the amounts on this page are meant purely as
        estimates to be used as a guide, not as quotes or set prices
        in any form. If you have questions about any of the above,
        contact us.`;
    }
  };

  render() {
    const {
      location,
      percentDownpayment,
      price,
      traditionalBrokerage,
      toriiBrokerage,
      prepaidInfo,
    } = this.props;
    const parsedPrice = parseInt(parseNumber(price), 10);
    const parsedDownpayment = parseInt(parseNumber(percentDownpayment), 10);
    const closingCosts = this.state.showToriiBrokerage
      ? toriiBrokerage.closingCosts
      : traditionalBrokerage.closingCosts;
    const closingCostsItems = this.state.showToriiBrokerage
      ? toriiBrokerage.items
      : traditionalBrokerage.items;
    return (
      <div className={`row ${styles.closingCostItems}`}>
        <div className={`column ${styles.column1}`}>
          <div className={`row ${styles.closingCostHeader}`}>
            <div className="column col-xs-12 col-sm-6 first">
              <p className={styles.closingCostHeaderLabel}>Loan Amount</p>
              <div className={styles.closingCostHeaderSeparator} />
              <h3 className={styles.closingCostHeaderValue}>
                {formatAsDollars(parsedPrice * (1 - parsedDownpayment / 100))}
              </h3>
            </div>
            <div className="column col-xs-12 col-sm-6">
              <p className={styles.closingCostHeaderLabel}>
                Downpayment Amount
              </p>
              <div className={styles.closingCostHeaderSeparator} />
              <h3 className={styles.closingCostHeaderValue}>
                {formatAsDollars(parsedPrice * (parsedDownpayment / 100))}
              </h3>
            </div>
          </div>
          <ClosingCostsTable
            closingCosts={closingCosts}
            closingCostsItems={closingCostsItems}
            showToriiBrokerage={this.state.showToriiBrokerage}
            toggleSwitch={this.toggleSwitch}
          />
          <PrepaidsTable prepaidInfo={prepaidInfo} />
          <div className="disclaimer">{this.disclaimerText(location)}</div>
        </div>
      </div>
    );
  }
}

export default ClosingCosts;
